import { CHANNEL_INTERFACE_TYPE } from '@/enums';

/**
 * 页面配置
 * @typedef {Object} PageConfig
 * @property {string} advertiser 渠道枚举值
 * @property {string[]} word_list 动态词包列表
 * @property {string} word_template 动态词包模板
 * @property {Object} rules 规则
 * @property {number} rules.min_length 标题最小长度
 * @property {number} rules.max_length 标题最大长度
 * @property {number} rules.max_count 标题最大个数
 * @property {number} rules.use_word_limit 允许使用词包总个数，为0则不限制
 * @property {Function} getUseWordCount 获取使用词包个数
 */

/**
 * 根据权限获取页面配置
 * @param {string} permission 页面权限值
 * @returns {PageConfig}
 */
export function getPageConfig(permission) {
  const base_key = 'title-list';
  const config = {
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.HUAWEI}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.HUAWEI,
      word_list: ['日期', '地点', '性别'],
      word_template: '{context}',
      rules: {
        min_length: 1,
        max_length: 22,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /\{[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.OPPO}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.OPPO,
      word_list: ['城市', '时间', '星期', '男生女生'],
      word_template: '{context}',
      rules: {
        min_length: 1,
        max_length: 35,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /\{[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.GDT}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.GDT,
      word_list: ['城市', '性别', '日期', '星期'],
      word_template: '{{context}}',
      rules: {
        min_length: 1,
        max_length: 30,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /{{[^}]*}}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.BAIDU}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.BAIDU,
      word_list: ['地域', '性别', '日期', '星期'],
      word_template: '#{context}',
      rules: {
        min_length: 1,
        max_length: 60,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /#{[^}]*}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.BILIBILI}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.BILIBILI,
      word_list: ['地域', '性别', '设备', '年龄'],
      word_template: '{智能context}',
      rules: {
        min_length: 1,
        max_length: 40,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /\{智能[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.JRTT}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.JRTT,
      word_list: ['地点', '日期', '星期', '年龄'],
      word_template: '{context}',
      rules: {
        min_length: 1,
        max_length: 55,
        max_count: 200,
        use_word_limit: 2,
      },
      getUseWordCount(val) {
        const regex = /\{[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.VIVO}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.VIVO,
      word_list: ['省份', '城市', '日期'],
      word_template: '{推荐context}',
      rules: {
        min_length: 1,
        max_length: 26,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /\{[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.XIAOMI}`]: {
      advertiser: CHANNEL_INTERFACE_TYPE.XIAOMI,
      word_list: ['城市', '省份', '日期', '性别'],
      word_template: '{context}',
      rules: {
        min_length: 1,
        max_length: 26,
        max_count: 200,
        use_word_limit: 0,
      },
      getUseWordCount(val) {
        const regex = /\{[^}]*\}/g;
        const matches = val.match(regex);
        return matches ? matches.length : 0;
      },
    },
  };
  return config[permission] || config[`${base_key}-${CHANNEL_INTERFACE_TYPE.GDT}`];
}
